import script from "./SVGRect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SVGRect.vue?vue&type=script&setup=true&lang=ts"

import "./SVGRect.vue?vue&type=style&index=0&id=0fd02500&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd02500"]])

export default __exports__